import React from 'react'
import { LocalizedText, Navbar, LinkNavbarItem } from 'labguard-cdk'
import {
  ChannelIcon,
  GroupIcon,
  UsersIcon,
  UserIcon,
  DutiesIcon,
  SystemSettingsIcon,
  ChartsIcon,
  AuditTrailsIcon,
  AlarmIcon,
} from 'src/components/common'
import { useAppPermission } from 'src/hooks'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'
import { formatUserName } from 'src/services'
import { useIntl } from 'react-intl'
import SystemAlarmsIconBadge from './SystemAlarmsIconBadge'
import LogoutNavbarItem from './LogoutNavbarItem'
import HelpNavbarItem from './HelpNavbarItem'
import styles from './TopNavbar.scss'

const query = gql`
  query me {
    account {
      id
      firstname
      lastname
    }
  }
`

const TopNavbar = () => {
  const showUsers = useAppPermission('users.read')
  const showGroups = useAppPermission('groups.read')
  const showChannels = useAppPermission('channels.read')
  const showGraphic = useAppPermission('channels.read')
  const showDuties = useAppPermission('duties.read')
  const showAlarms = useAppPermission('alarms.read')
  const showAuditTrails = useAppPermission('auditTrails.read')
  const showSystemSettings = useAppPermission('systemSettings.read')
  const showSystemAlarms = useAppPermission('systemAlarms.read')

  const { data: { account } = {} } = useQuery(query)
  const intl = useIntl()

  return (
    <Navbar>
      <div className={styles.left}>
        {showUsers && <LinkNavbarItem icon={UsersIcon} to="/users" label={<LocalizedText id="WEB_USERS" />} />}
        {showGroups && <LinkNavbarItem icon={GroupIcon} to="/groups" label={<LocalizedText id="WEB_GROUPS" />} />}
        {showChannels && (
          <LinkNavbarItem icon={ChannelIcon} to="/channels" label={<LocalizedText id="WEB_CHANNELS" />} />
        )}
        {showDuties && <LinkNavbarItem icon={DutiesIcon} to="/duties" label={<LocalizedText id="WEB_DUTIES" />} />}
        {showGraphic && <LinkNavbarItem icon={ChartsIcon} to="/charts" label={<LocalizedText id="WEB_GRAPHIC" />} />}
        {showAlarms && (
          <LinkNavbarItem icon={AlarmIcon} to="/channel-alarms" label={<LocalizedText id="WEB_ALARMS" />} />
        )}
        {showAuditTrails && (
          <LinkNavbarItem icon={AuditTrailsIcon} to="/audit-trail" label={<LocalizedText id="WEB_AUDIT_TRAIL" />} />
        )}
      </div>
      <div className={styles.right}>
        <LinkNavbarItem
          icon={UserIcon}
          to="/account"
          tooltip={<LocalizedText id="WEB_MY_ACCOUNT" />}
          leftLabel={formatUserName(intl, account)}
        />
        {showSystemAlarms && (
          <LinkNavbarItem
            icon={SystemAlarmsIconBadge}
            to="system-alarms"
            tooltip={<LocalizedText id="WEB_SYSTEM_ALERTS" />}
          />
        )}
        {showSystemSettings && (
          <LinkNavbarItem
            icon={SystemSettingsIcon}
            to="/system-settings"
            tooltip={<LocalizedText id="WEB_SYSTEM_SETTINGS" />}
          />
        )}
        <HelpNavbarItem />
        <LogoutNavbarItem />
      </div>
    </Navbar>
  )
}

export default TopNavbar
